export type BundleCallback = (bundled: string) => void;
